import { FilterDocument, UserSettings } from '@griply/types';

import { upcomingFilters } from './constants/upcoming-page-options';
import { pickFilterOptions } from './pick-filter-options';

// Grouping (fixed) and showCompleted (Show Completed toggle) are not mapped here.
export const mapPartialToUpcomingSettings = (
  partial: Partial<FilterDocument>,
): Partial<UserSettings> | null => {
  const settings: Partial<UserSettings> = {};
  const upcomingFiltersSlot: Partial<FilterDocument> = {};

  if (partial.sortingMode !== undefined) {
    settings.upcoming = { sortingMode: partial.sortingMode ?? undefined };
  }

  if (partial.filters !== undefined) {
    const filters = partial.filters;

    upcomingFiltersSlot.filters =
      filters === null ? null : pickFilterOptions(filters, upcomingFilters);
  }

  if (Object.keys(upcomingFiltersSlot).length) {
    settings.filters = { upcoming: upcomingFiltersSlot };
  }

  if (!Object.keys(settings).length) {
    return null;
  }

  return settings;
};
